<template>
  <transition name="modal-fade">
    <div @click.self="close"  class="modal-backdrop" >
      <div class="modal"
           role="dialog"
           aria-labelledby="modalTitle"
           aria-describedby="modalDescription">
        <div class="modal-container">
          <div @click="close" class="wrap-back-button">
            <span>
              Close
            </span>
          </div>
          <div class="wrap-print-button" >
            <button class="btn btn-primary" onclick="window.print()">Print</button>
          </div>
          <div class="title" name="title">
            <p><span class="english-title">{{ Festival.title }} </span></p>
            <p><span class="german-title">{{`${this.getNiceDate(Festival.event_date_start)} - ${this.getNiceDate(Festival.event_date_end)}` }}</span></p>
          </div>
          <div class="modal-content">
            <div class="wrap-details">
              <p v-if="Festival.year_of_foundation"><span class="strong">Year of foundation: </span> <span class="detail-value" v-html="Festival.year_of_foundation"/></p>
              <p v-if="Festival.length_in_minutes"><span class="strong">Maximum length: </span> <span class="detail-value" v-html="Festival.length_in_minutes + ' min'"/></p>
              <p v-if="Festival.format.length >= 1"><span class="strong">Format: </span> <span class="detail-value" v-html="Festival.format.toString()"/></p>
              <p v-if="Festival.registration_deadline"><span class="strong">Registration deadline: </span> <span class="detail-value"> {{`${this.getNiceDate(Festival.registration_deadline)}`}}</span> </p>
              <p v-if="Festival.early_deadline"><span class="strong">Early deadline: </span> <span class="detail-value"> {{`${this.getNiceDate(Festival.early_deadline)}`}}</span></p>
              <p v-if="Festival.late_deadline"><span class="strong">Late deadline: </span> <span class="detail-value"> {{`${this.getNiceDate(Festival.late_deadline)}`}}</span></p>
              <p v-if="Festival.registration_deadline_text"><span class="strong"> </span> <span class="detail-value" v-html="Festival.registration_deadline_text.replace(/(?:\r\n|\r|\n)/g, '<br/>')"></span></p>
              <p v-if="Festival.fees"><span class="strong">Fees: </span> <span class="detail-value" v-html="Festival.fees"/></p>
              <p v-if="Festival.attendance"><span class="strong">Attendance figures: </span> <span class="detail-value" v-html="Festival.attendance"/></p>
              <p v-if="Festival.city"><span class="strong">City: </span> <span class="detail-value" v-html="Festival.city"/></p>
              <p v-if="Festival.countryName"><span class="strong">Country: </span> <span class="detail-value" v-html="Festival.countryName"/></p>
              <!--                Links-->
              <p >
                <span v-if="Festival.shortfilmdepot || Festival.filmfreeway || Festival.filmfestplatform" class="strong">Submission Link:</span>
                <ul class="list detail-value">
                  <li  v-if="Festival.shortfilmdepot"><a  :href="Festival.shortfilmdepot">{{ this.$store.state.texts.shortfilmdepot }}</a></li>
                  <li  v-if="Festival.filmfreeway"><a :href="Festival.filmfreeway">{{ this.$store.state.texts.filmfreeway }}</a></li>
                  <li  v-if="Festival.filmfestplatform"><a :href="Festival.filmfestplatform">{{ this.$store.state.texts.filmfestplatform }}</a></li>
                </ul>
              </p>
              <p  v-if="Festival.festhome"><a :href="Festival.festhome">{{ this.$store.state.texts.festhome }}</a></p>
              <p  v-if="Festival.eventival"><a :href="Festival.eventival">{{ this.$store.state.texts.eventival }}</a></p>

              <p  v-if="Festival.category.length >= 1"><span class="strong">Category: </span> <span class="detail-value" v-html="Festival.category.toString()"/></p>
              <p  v-if="Festival.genre.length >= 1"><span class="strong">Genre: </span> <span class="detail-value" v-html="Festival.genre.toString()"/></p>
              <p  v-if="Festival.subtitle_en > 1 || Festival.subtitle_fr > 1 || Festival.subtitle_de > 1 ||
                       Festival.subtitle_it > 1 || Festival.subtitle_es > 1">
                <span class="strong">Subtitles:</span>
                <span class="detail-value">
                  <span v-if="Festival.subtitle_en === 2">English subtitles recommended</span><span v-if="Festival.subtitle_en === 3">English subtitles necessary</span>
                  <span v-if="Festival.subtitle_fr === 2">&nbsp;French subtitles recommended</span><span v-if="Festival.subtitle_fr === 3">&nbsp;French subtitles necessary</span>
                  <span v-if="Festival.subtitle_de === 2">&nbsp;German subtitles recommended</span><span v-if="Festival.subtitle_de === 3">&nbsp;German subtitles necessary</span>
                  <span v-if="Festival.subtitle_it === 2">&nbsp;Italian subtitles recommended</span><span v-if="Festival.subtitle_it === 3">&nbsp;Italian subtitles necessary</span>
                  <span v-if="Festival.subtitle_es === 2">&nbsp;Spanish subtitles recommended</span><span v-if="Festival.subtitle_es === 3">&nbsp;Spanish subtitles necessary</span>
                </span>
              </p>
              <p v-if="Festival.participants" ><span class="strong">Participants of the film Industry: </span> <span class="detail-value" v-html="Festival.participants"/></p>
              <p v-if="Festival.number_of_films_shown" ><span class="strong">Number of shown films: </span> <span class="detail-value" v-html="Festival.number_of_films_shown"/></p>
              <p v-if="Festival.enent_date_text" ><span class="strong">Event date text: </span> <span class="detail-value" v-html="Festival.event_date_text"/></p>
              <p v-if="Festival.media_coverage" ><span class="strong">Media coverage: </span> <span class="detail-value" v-html="Festival.media_coverage.replace(/(?:\r\n|\r|\n)/g, '<br/>')"/></p>
              <p v-if="Festival.services" ><span class="strong">Services: </span> <span class="detail-value" v-html="Festival.services.replace(/(?:\r\n|\r|\n)/g, '<br/>')"/></p>
              <p v-if="Festival.prizes_for_german_films" >
                <span class="strong">Prizes: </span>
                <span v-html="Festival.prizes_for_german_films.replace(/(?:\r\n|\r|\n)/g, '<br/>')" class="detail-value"/>
              </p>

              <p v-if="Festival.specific_fiapf != 0 ||Festival.specific_efa === 1
              || Festival.oscar_action_animation_short === 1 || Festival.oscar_documentary === 1 || Festival.student_aaq === 1
              || Festival.melies_award_quali === 1 || Festival.ffa_short_film_fund === 1 || Festival.member_ag_kurzfilm === 1" >
                <span class="strong">Specific characteristics:</span>
                <span class="detail-value">
                <span v-if="Festival.specific_fiapf" v-html="`${Festival.specific_fiapf.toString()} &nbsp;`"/>
                <span v-if="Festival.specific_efa === 1">{{ this.$store.state.texts.specific_efa_text }} &nbsp; </span>
                <span v-if="Festival.oscar_action_animation_short === 1">{{ this.$store.state.texts.oscar_action_animation_short_text }} &nbsp; </span>
                <span v-if="Festival.oscar_documentary === 1">{{ this.$store.state.texts.oscar_documentary_text }} &nbsp; </span>
                <span v-if="Festival.student_aaq === 1">{{ this.$store.state.texts.student_aaq_text }} &nbsp; </span>
                <span v-if="Festival.melies_award_quali === 1">{{ this.$store.state.texts.melies_award_quali_text }} &nbsp; </span>
                <span v-if="Festival.ffa_short_film_fund === 1">{{ this.$store.state.texts.ffa_short_film_fund_text }} &nbsp; </span>
                <span v-if="Festival.member_ag_kurzfilm === 1">{{ this.$store.state.texts.member_ag_kurzfilm_text }}</span>
                </span>
              </p>
            </div>
            <div class="wrap-details text" >
              <p v-if="Festival.sections_text"><span class="strong">Sections</span> <span class="detail-value" v-html="Festival.sections_text.replace(/(?:\r\n|\r|\n)/g, '<br/>')"></span></p>
              <p v-if="Festival.terms_of_entry"><span class="strong">Terms of entry</span><span class="detail-value" v-html="Festival.terms_of_entry.replace(/(?:\r\n|\r|\n)/g, '<br/>')"></span> </p>
              <p v-if="Festival.evaluation"><span class="strong">Evaluation</span> <span class="detail-value" v-html="Festival.evaluation.replace(/(?:\r\n|\r|\n)/g, '<br/>')"></span></p>
              <p v-if="Festival.awards_text"><span class="strong">Prizes/Awards</span><span class="detail-value" v-html="Festival.awards_text.replace(/(?:\r\n|\r|\n)/g, '<br/>')"></span> </p>
              <p v-if="Festival.german_films_presented">
                <span class="strong">German films presented: </span>
                <span class="detail-value" v-html="Festival.german_films_presented"></span>
              </p>
            </div>
            <div class="wrap-details">
              <p >
                <span v-if="Festival.address.title || Festival.address.address" class="strong">Address:</span>
              <ul class="list detail-value">
                <li v-if="Festival.address.title" v-html="Festival.address.title"/>
                <li v-if="Festival.address.address" v-html="Festival.address.address"/>
                <li v-if="Festival.address.zip" v-html="Festival.address.zip"/>
                <li v-if="Festival.address.city" v-html="Festival.address.city"/>
                <li v-if="Festival.address.country" v-html="Festival.address.country"/>
                <li v-if="Festival.address.phone" ><a :href="`tel:${Festival.address.phone}`"> {{ Festival.address.phone }}</a></li>
                <li v-if="Festival.url || Festival.address.url" >
                  <a v-if="Festival.url" :href="`${Festival.url}`"> {{ Festival.url }}</a>
                  <a v-else :href="`${Festival.address.url}`"> {{ Festival.address.url }}</a>
                </li>
                <li v-if="Festival.email || Festival.address.email" >
                  <a v-if="Festival.email" :href="`mailto:${Festival.email}`"> {{ Festival.email }}</a>
                  <a v-else :href="`mailto:${Festival.address.email}`"> {{ Festival.address.email }}</a>
                </li>
              </ul>
              </p>
<!--              eslint-disable -->
              <p v-if="Festival.functions.length > 0" v-for="functionary in Festival.functions" :key="functionary.title" >
                <span class="strong" v-html="functionary.title"></span>
                <ul class="list detail-value">
                  <li v-html="functionary.text"/>
                  <li v-if="functionary.email" ><a :href="`mailto:${functionary.email}`"> {{ functionary.email }}</a></li>
                </ul>
              </p>
            </div>

          </div>
          <div @click="close" class="wrap-back-button">
            <span>
              Close
            </span>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  data() {
    return {
      Festival: this.$store.getters.getSelectedFestival,
    };
  },
  name: 'Modal',
  methods: {
    close() {
      const { vueURL } = this.$store.state;
      this.$store.commit('updateSelectedFestivalCard', 0);
      this.$router.push({ path: this.$store.state.site, query: vueURL });
    },
    getNiceDate(unixTimestamp) {
      const timestamp = new Date(unixTimestamp * 1000);
      const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      const year = timestamp.getFullYear();
      const month = months[timestamp.getMonth()];
      const date = timestamp.getDate();
      const output = `${date} ${month} ${year}`;
      return output;
    },
  },
};
</script>
<style>
.wrap-print-button{
  display: flex;
  align-items: center;
  justify-content: flex-end;
  color: #3c3c3c;
}

.wrap-details .detail-value p{
  margin: 0;
}
.wrap-back-button:after {
  font-family: "icomoon";
  font-size: 2rem;
  font-weight: 400;
  content: "\e90c";
  margin-right: 10px;
  vertical-align: middle;
}

.wrap-back-button span{
  transition: margin-right .2s;
  margin-right: 10px;
}

.wrap-back-button:hover span{
  margin-right: 0;
}

.list {
  list-style: none;
  padding: 0;
  margin: 0;
}
.wrap-wide{
  width: calc(100% - 1rem);
  padding: 0.5rem 0.5rem;
  border-top: 1px solid #dfdfdf;
  border-bottom: 1px solid #dfdfdf;
  margin: 0.5rem 0;
}

.wrap-details .xwide{
  width: calc(100% - 2rem) !important;
  display: block;
}

.german-title{
  font-size: 1.2rem;
}
.english-title{
  font-weight: bold;
}
</style>
